(function() {

  var SVG_BOTTLE_FULL = '<svg width="36" height="42" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<rect x="9" y="0" width="4" height="3" rx="1" fill="currentColor"/>'
    + '<rect x="8" y="3" width="6" height="3" rx="1" fill="currentColor"/>'
    + '<path d="M3 8 Q3 6 5 6 L17 6 Q19 6 19 8 L19 22 Q19 24 17 24 L5 24 Q3 24 3 22 Z" fill="currentColor"/>'
    + '<path d="M3 14 Q11 11 19 14" stroke="white" stroke-width="1.2" fill="none"/>'
    + '</svg>';

  var SVG_BOTTLE_HALF = '<svg width="32" height="38" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<rect x="9" y="0" width="4" height="3" rx="1" fill="currentColor"/>'
    + '<rect x="8" y="3" width="6" height="3" rx="1" fill="currentColor"/>'
    + '<path class="og-stroke-only" d="M3 8 Q3 6 5 6 L17 6 Q19 6 19 8 L19 22 Q19 24 17 24 L5 24 Q3 24 3 22 Z" stroke="currentColor" stroke-width="1.5" fill="none"/>'
    + '<path class="og-fill-only" d="M3.8 15 Q3.8 14 5 14 L17 14 Q18.2 14 18.2 15 L18.2 22 Q18.2 23.5 17 23.5 L5 23.5 Q3.8 23.5 3.8 22 Z" fill="currentColor"/>'
    + '</svg>';

  var SVG_DROP = '<svg width="18" height="26" viewBox="0 0 14 20" fill="none"><path d="M7 1 C7 1 2 8 2 13 C2 16.3 4.2 19 7 19 C9.8 19 12 16.3 12 13 C12 8 7 1 7 1Z" fill="currentColor"/></svg>';

  function injectIcons() {
    var labels = document.querySelectorAll('.halo-productOptions .product-form__label');
    labels.forEach(function(label) {
      if (label.querySelector('.og-icon')) return;
      var textSpan = label.querySelector('.text');
      if (!textSpan) return;
      var txt = textSpan.textContent.replace(/\*/g, '').trim().toLowerCase();
      var iconSpan = document.createElement('span');
      iconSpan.className = 'og-icon';
      iconSpan.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:2px;margin-bottom:6px;color:#888;min-height:38px;background:none;';
      if (txt.indexOf('full') !== -1 || txt.indexOf('100ml') !== -1 || txt.indexOf('150ml') !== -1) {
        iconSpan.innerHTML = SVG_BOTTLE_FULL;
      } else if (txt.indexOf('30ml') !== -1) {
        iconSpan.innerHTML = SVG_DROP + SVG_DROP + SVG_DROP;
      } else if (txt.indexOf('10ml') !== -1) {
        iconSpan.innerHTML = SVG_DROP;
      } else if (txt.indexOf('كمية') !== -1 || txt.indexOf('زجاجة') !== -1 || txt.indexOf('50') !== -1) {
        iconSpan.innerHTML = SVG_BOTTLE_HALF;
      } else {
        return;
      }
      label.insertBefore(iconSpan, textSpan);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectIcons);
  } else {
    injectIcons();
  }

  document.addEventListener('variant:change', injectIcons);
  setTimeout(injectIcons, 800);
  setTimeout(injectIcons, 2000);
})();
